<template>
  <div class="">
    <div :class="pgLoading ? 'hidden' : ''">
      <header id="top-menu">
        <!-- <HeaderTop></HeaderTop> -->
        <Header v-if="$route.meta.hideComponents != true"></Header>
      </header>

      <Aside v-if="$route.meta.hideComponents != true"> ></Aside>

      <!-- <div class="body-overlay"></div> -->

      <main>
        <router-view />
        <Footer v-if="$route.meta.hideComponents != true"> </Footer>
      </main>
    </div>

    <div :class="!pgLoading ? 'hidden' : ''">
      <div>
        <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
    // HeaderTop: () => import('@/components/HeaderTop.vue'),
    Header: () => import("@/components/Header.vue"),
    Aside: () => import("@/components/Aside.vue"),
    Footer: () => import("@/components/Footer.vue"),
  },
  data() {
    return {
      //
      pgLoading: false,
    };
  },
  watch: {
    //
  },
  created() {
    //
    // this.showLoading();
    // this.fetchAddress();
    // this.fetchPhone();
    // this.fetchEmail();
    // this.fetchBio();
  },
  methods: {
    //
    showLoading() {
      //setTimeout(() => this.pgLoading = false, 1000);
    },

    fetchAddress() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/address",
        method: "GET",
        data: {},
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          localStorage.setItem(
            "settings.en.address",
            res.data.data.en.body_striped
          );
          localStorage.setItem(
            "settings.ar.address",
            res.data.data.ar.body_striped
          );
        })
        .catch(() => { })
        .finally(() => { });
    },

    fetchPhone() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/phone",
        method: "GET",
        data: {},
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          localStorage.setItem(
            "settings.en.phone",
            res.data.data.en.body_striped
          );
          localStorage.setItem(
            "settings.ar.phone",
            res.data.data.ar.body_striped
          );
        })
        .catch(() => { })
        .finally(() => { });
    },

    fetchEmail() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/email",
        method: "GET",
        data: {},
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          localStorage.setItem(
            "settings.en.email",
            res.data.data.en.body_striped
          );
          localStorage.setItem(
            "settings.ar.email",
            res.data.data.ar.body_striped
          );
        })
        .catch(() => { })
        .finally(() => { });
    },

    fetchBio() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/bio",
        method: "GET",
        data: {},
      };
      this.axios(options)
        .then((res) => {
          this.pgLoading = false;
          localStorage.setItem(
            "settings.en.bio",
            res.data.data.en.body_striped
          );
          localStorage.setItem(
            "settings.ar.bio",
            res.data.data.ar.body_striped
          );
        })
        .catch(() => { })
        .finally(() => { });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hidden {
  display: none;
}
</style>
